export default "__VITE_ASSET__Bn0HCDvR__"